<template>
    <div class="application-center-info">
        <!-- 面包屑导航 -->
        <div class="breadcrumb" v-if="listParams.searchtext">
            <span class="back" @click="goBack"> <i class="el-icon-arrow-left"></i> 返回 </span>
            <span
            >以为您找到{{ listData.total }}条 "<span>{{ listParams.searchtext }}</span
            >" 的素材</span
            >
        </div>

        <!-- 筛选区域 -->
        <screen-cells
            v-if="refresh"
            :parenttypecode="parenttypecode"
            :typecode="listParams.typecode"
            :sortingrule="listParams.sortingrule"
            @change="handleScreen"
        ></screen-cells>

        <div class="list-wrap" v-show="listData.total">
            <!-- 搜索结果列表 -->
            <material-list ref="list" @listItemClick="listItemClick" :data="listData.list"></material-list>

            <div
                class="loading"
                :class="{
                    animate: listData.list.length < listData.total
                }"
                v-show="loading"
            >
                <span>
                    {{ loadingText }}
                </span>
            </div>
        </div>
        <div v-show="!listData.total && listData.isLoad" class="none-data">
            暂无数据
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import MaterialList from './components/material-list.vue';
import ScreenCells from './components/screen-cells.vue';
import fa from "element-ui/src/locale/lang/fa";

export default {
    name: 'ApplicationCenterInfo',
    components: {
        MaterialList,
        ScreenCells
    },
    data() {
        return {
            refresh: true,
            screenData: [],
            parenttypecode: '',
            listParams: {
                typecode: '', // 类别  热门推荐hot 其他类型给对应代码项或者guid
                searchtext: '', // 关键词
                pagesize_lowerlimit: '', // 素材页数下限
                pagesize_upperlimit: '', // 素材页数上限
                shopguid: '', // 素材所属店铺
                consumer: {
                    userguid: '',
                    consumerule: ''
                }, // 素材消费者
                sortingrule: '', // 排序规则
                pageindex: 0,
                pagesize: 12
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            },
            loading: false
        };
    },
    computed: {
        loadingText() {
            return this.listData.list.length < this.listData.total ? '正在加载' : '没有更多数据了';
        }
    },
    watch: {
        $route(val) {
            this.init(val.query);
        }
    },
    created() {
        this.init(this.$route.query);
        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // 组件销毁时移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        ...mapActions(['openMaterialDetailDialog']),
        init(data) {
            this.parenttypecode = data.parenttypecode || '';
            this.listParams.typecode = data.typecode || '';
            this.listParams.searchtext = data.keyword || '';
            this.listParams.sortingrule = data.sortingrule || '';

            if (this.listParams.typecode === 'hot') {
                this.listParams.typecode = '';
            }

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        // 返回上一页
        goBack() {
            this.$router.push({
                name: 'ApplicationCenterHome'
            });
        },
        getList() {
            this.loading = true;

            this.$Api.getApplicationCenterList(this.listParams).then((data) => {
                this.loading = false;
                this.listData.list = this.listData.list.concat(data.materiallist);
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
                this.$nextTick(() => {
                    let listHeight = this.$refs.list.$el.offsetHeight;
                    let clientHeight = document.documentElement.clientHeight;
                    if (listHeight < clientHeight && this.listData.list.length < this.listData.total) {
                        this.listParams.pageindex++;
                        this.getList();
                    }
                });
            });
        },
        handleScreen(data) {
            this.listParams = {
                ...this.listParams,
                ...data
            };
            this.listParams.pageindex = 0;
            this.listData.list = [];
            this.getList();
        },
        // 处理滚动事件
        handleScroll() {
            // 获取页面滚动位置
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = document.documentElement.scrollHeight;

            // 判断是否滚动到底部（距离底部20px时触发）
            if (scrollHeight - scrollTop - clientHeight <= 32) {
                // 如果还有更多数据
                if (!this.loading && this.listData.list.length < this.listData.total) {
                    this.listParams.pageindex++;
                    this.getList();
                } else {
                    this.loading = true;
                }
            }
        },
        // 列表点击
        listItemClick(data) {
            this.openMaterialDetailDialog(data.materialguid);
        }
    }
};
</script>

<style lang="scss" scoped>
@import './style/common.scss';
@import './style/application-center-info.scss';
</style>
